import { useEffect, useState } from 'react';
import { CrmApi } from '../../api/resources';

/** Statuses, staff and custom-field definitions needed by CRM forms. */
export default function useCrmLookups() {
  const [state, setState] = useState({
    statuses: [],
    users: [],
    leadFields: [],
    followupFields: [],
    ready: false,
  });

  useEffect(() => {
    let alive = true;
    Promise.all([CrmApi.lookups(), CrmApi.customFields.list()])
      .then(([lookups, fields]) => {
        if (!alive) return;
        const active = fields.filter((f) => f.is_active);
        setState({
          statuses: lookups.statuses,
          users: lookups.users,
          leadFields: active.filter((f) => f.entity === 'lead'),
          followupFields: active.filter((f) => f.entity === 'followup'),
          ready: true,
        });
      })
      .catch(() => alive && setState((s) => ({ ...s, ready: true })));
    return () => {
      alive = false;
    };
  }, []);

  return state;
}

export function StatusBadge({ status }) {
  if (!status) return <span className="muted">—</span>;
  return (
    <span
      className="badge"
      style={{ background: `${status.color}22`, color: status.color }}
    >
      {status.name}
    </span>
  );
}

/** ISO string -> value for <input type="datetime-local"> (local time). */
export function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

/** <input type="datetime-local"> value (local time) -> UTC ISO string for the API. */
export function fromLocalInput(value) {
  return value ? new Date(value).toISOString() : null;
}

export function fmtDate(iso) {
  return iso ? new Date(iso).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' }) : '—';
}
